module.exports = __webpack_public_path__ + "images/home-dingtalk-work/phone@2x-80109fb5559c48d925c67c139ad91eab.png";